"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShowBounds = exports.createBoundsPolygon = void 0;
var _react = require("react");
var _styledLib = require("@caps-mobile/styled-lib");
// libraries 

var LAT_INSET = 0.0004;
var LNG_INSET = 0.0001;
var extractBoundsArray = function extractBoundsArray(bounds) {
  var boundsArray = [];
  boundsArray.push({
    latitude: bounds[0] - bounds[0] * LAT_INSET,
    longitude: bounds[1] - bounds[1] * LNG_INSET
  });
  boundsArray.push({
    latitude: bounds[3] - bounds[3] * LAT_INSET,
    longitude: bounds[4] + bounds[4] * LNG_INSET
  });
  boundsArray.push({
    latitude: bounds[6] + bounds[6] * LAT_INSET,
    longitude: bounds[7] + bounds[7] * LNG_INSET
  });
  boundsArray.push({
    latitude: bounds[9] + bounds[9] * LAT_INSET,
    longitude: bounds[10] - bounds[10] * LNG_INSET
  });
  return boundsArray;
};
var createBoundsPolygon = function createBoundsPolygon(bounds) {
  if (!bounds || bounds.length < 4) return null;
  return {
    "type": "Feature",
    "properties": {
      "zIndex": 999,
      "category": {
        "fillColor": {
          "red": 230,
          "green": 102,
          "blue": 55,
          "alpha": 0.2,
          "hex": "E66637"
        },
        "strokeColor": {
          "red": 230,
          "green": 102,
          "blue": 55,
          "alpha": 1.0,
          "hex": "E66637"
        }
      }
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[bounds[0].longitude, bounds[0].latitude], [bounds[1].longitude, bounds[1].latitude], [bounds[2].longitude, bounds[2].latitude], [bounds[3].longitude, bounds[3].latitude]]]
    }
  };
};
exports.createBoundsPolygon = createBoundsPolygon;
var useShowBounds = function useShowBounds(map) {
  var showBounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  (0, _react.useEffect)(function () {
    if (map && showBounds) {
      var viewModel = map.getViewModel();
      var modelData = viewModel.getLookAtData();
      var mapBounds = modelData === null || modelData === void 0 ? void 0 : modelData.bounds;
      var bounds = mapBounds === null || mapBounds === void 0 ? void 0 : mapBounds.b.X;
      if (!bounds) return;
      var feature = createBoundsPolygon(extractBoundsArray(bounds));
      if (!feature) return;
      var reader = new H.data.geojson.Reader(undefined,
      // optional url string (to a geojson file)
      {
        style: function style(mapObject) {
          if (mapObject instanceof H.map.Polygon) {
            mapObject.setStyle({
              fillColor: feature ? (0, _styledLib.rgbaBuilder)(feature.properties.category.fillColor) : "rgba(255, 0, 0, 0.1)",
              strokeColor: feature ? (0, _styledLib.rgbaBuilder)(feature.properties.category.strokeColor) : "rgba(255, 0, 0, 1)",
              lineWidth: 3
            });
            map.addObject(mapObject);
          }
        }
      });
      reader.parseData(feature);
      reader = null;
    }
  }, [map, showBounds]);
};
exports.useShowBounds = useShowBounds;